import { render, staticRenderFns } from "./couponManager.vue?vue&type=template&id=1baeafd9&scoped=true&"
import script from "@/scripts/promotion/couponManager.js?vue&type=script&lang=js&"
export * from "@/scripts/promotion/couponManager.js?vue&type=script&lang=js&"
import style0 from "./couponManager.vue?vue&type=style&index=0&id=1baeafd9&prod&lang=css&"
import style1 from "./couponManager.vue?vue&type=style&index=1&id=1baeafd9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baeafd9",
  null
  
)

export default component.exports